import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RLabelProps {
    children: React.ReactNode;
    htmlFor?: string;
    className?: string;
}

export function RLabel({ children, htmlFor, className }: RLabelProps) {
    return (
        <Label htmlFor={htmlFor} className={className}>
            {children}
        </Label>
    );
}

const Label = styled('label')({
    fontSize: 14,
    fontWeight: 600,
    color: Colors.darkNavy,
});
